export default __webpack_public_path__ + "static/media/Travel.fe67fe20.svg";